import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trans } from '../../../localization/language';
import * as mobileActions from '../../../actions/mobile';
import { CUSTOM_SERVICE_URL } from '../../../constants';

class NeedBindMobile extends React.Component {
	handleClick() {
		this.props.initMobile();
	}

	render() {
		var csLink = CUSTOM_SERVICE_URL[this.props.userInfo.acc_country] || CUSTOM_SERVICE_URL['INTL'];
		console.log(this.props);
		return (
			<div className="content">
				<div className="content-item content-item--ipage">
					<div className="content-item__title">
						{trans('change_password_title')}
					</div>
					<div className="content-item__main">
						<div className="content-item--ipage__main">
							<div className="setupauth-binddesc">
								{trans('bind_mobile_hint')+' '}
							</div>
							<div className="setupauth-binddesc">
								{trans('no_mobile_hint')+' '}<a href={`${csLink}`} className="customer-service-link">{trans('customer_service')}</a>
							</div>
							<div className="content__submit-wrap">
								<a className="content__submit" href="#" onClick={this.handleClick.bind(this)}>
									{trans('bind_mobile_btn')}
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo,
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(Object.assign({}, mobileActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(NeedBindMobile);


// WEBPACK FOOTER //
// ./app/components/security/password/NeedBindMobile.js